(() => {
function $26ec02ac8ee2f49f$var$convertToDataTable(container) {
    const table = container.querySelector("table");
    const tbody = table.querySelector("tbody");
    const columns = [
        ...table.querySelectorAll("th")
    ];
    const rows = [
        ...tbody.querySelectorAll("tr")
    ].map((el)=>{
        const cells = [
            ...el.querySelectorAll("td")
        ];
        return {
            el: el,
            data: cells.map((td)=>({
                    numeric: !!td.dataset.value,
                    value: td.dataset.value ? parseInt(td.dataset.value, 10) : td.textContent
                }))
        };
    });
    let currentSortDir = "none";
    let currentSortColumn = "";
    let codeColumn = -1;
    const sortRows = (idx)=>{
        if (rows.length < 2) return;
        if (currentSortDir === "none") {
            tbody.replaceChildren(...rows.map((x)=>x.el));
            return;
        }
        const isNumericData = rows.some((row)=>row.data[idx].numeric);
        const sorted = isNumericData ? [
            ...rows
        ].sort((a, b)=>b.data[idx].value - a.data[idx].value) : [
            ...rows
        ].sort((a, b)=>a.data[idx].value.localeCompare(b.data[idx].value));
        if (currentSortDir === "desc") sorted.reverse();
        tbody.replaceChildren(...sorted.map((x)=>x.el));
    };
    columns.forEach((column, idx)=>{
        const columnName = column.textContent.trim();
        if (!columnName) return;
        if (columnName === "Code") codeColumn = idx;
        const columnSortWidget = document.createElement("span");
        columnSortWidget.textContent = "\u2195\uFE0F";
        column.appendChild(columnSortWidget);
        column.addEventListener("click", ()=>{
            table.querySelectorAll("th > span").forEach((el)=>el.textContent = "\u2195\uFE0F");
            if (currentSortColumn !== columnName) {
                currentSortDir = "asc";
                columnSortWidget.textContent = "\u2B06\uFE0F";
            } else {
                if (currentSortDir === "none") {
                    currentSortDir = "asc";
                    columnSortWidget.textContent = "\u2B06\uFE0F";
                } else if (currentSortDir === "asc") {
                    currentSortDir = "desc";
                    columnSortWidget.textContent = "\u2B07\uFE0F";
                } else {
                    currentSortDir = "none";
                    columnSortWidget.textContent = "\u2195\uFE0F";
                }
            }
            currentSortColumn = columnName;
            sortRows(idx);
        });
    });
    container.querySelector(".product-search")?.addEventListener("input", (evt)=>{
        if (codeColumn < 0) return;
        const codeQuery = evt.currentTarget.value.toLowerCase();
        rows.forEach(({ el: el, data: data })=>{
            el.style.display = data[codeColumn].value.toString().toLowerCase().includes(codeQuery) ? "" : "none";
        });
    });
}
document.addEventListener("DOMContentLoaded", ()=>{
    document.querySelectorAll(".poly-products-table").forEach($26ec02ac8ee2f49f$var$convertToDataTable);
});

})();
//# sourceMappingURL=index.js.map
